import { SidebarHeader } from "@/components/sidebar/components/SidebarHeader.tsx";
import { SidebarConfigItem } from "@/components/sidebar/sidebar-service.tsx";
import {
  getSettingsGroupLink,
  getSettingsVisibleToEmployee,
  isSettingsGroupActive,
} from "@/pages/settings/index/settings.types.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { Box, SidebarPanelItem, Stack, Title } from "@skailer-com/uikit";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const SidebarSettings = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const menuConfig = useMemo(() => {
    const items = [
      {
        title: t("common:overview"),
        to: "/settings",
        isActive: false,
      },
    ] as SidebarConfigItem[];
    for (let i = 0; i < items.length; i++) {
      items[i].isActive = pathname === items[i].to;
    }
    return items;
  }, [pathname]);

  const { data: employee } = useEmployeeMe();

  const menu = useMemo(() => {
    if (!employee) return [];
    return getSettingsVisibleToEmployee(employee);
  }, [employee]);

  return (
    <>
      <SidebarHeader title={t("common:settings")} />
      <Stack className={"px-4 pb-6"}>
        <Stack gap={"sm"}>
          {menuConfig.map((item, index) => (
            <SidebarPanelItem
              to={item.to || "/"}
              key={"sidebar-" + index}
              isActive={item.isActive}
              title={item.title}
            />
          ))}
        </Stack>
        {menu.map((category, index) => (
          <Fragment key={`sidebar-category-${index}`}>
            <Box className={"px-2"}>
              <Title header={category.title} size={"xs"} paddingBottom paddingTop />
            </Box>
            <Stack gap={"xs"}>
              {category.groups.map((group) => {
                return (
                  <SidebarPanelItem
                    key={`sidebar-group-${group.key}`}
                    to={getSettingsGroupLink(group)}
                    isActive={isSettingsGroupActive(group, pathname)}
                    title={group.title}
                  />
                );
              })}
            </Stack>
          </Fragment>
        ))}
      </Stack>
    </>
  );
};
